export default __webpack_public_path__ + "static/media/2.f62c37b3.mp3";